import { render, staticRenderFns } from "./UnreadMessageCounter.vue?vue&type=template&id=3e36bc7c&scoped=true"
import script from "./UnreadMessageCounter.vue?vue&type=script&lang=js"
export * from "./UnreadMessageCounter.vue?vue&type=script&lang=js"
import style0 from "./UnreadMessageCounter.vue?vue&type=style&index=0&id=3e36bc7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36bc7c",
  null
  
)

export default component.exports